import React, { useState } from 'react';
import { roundNumber, chartsMaxYTick } from '../../../../../utils';
import { withDefaultPrintChart } from '../../../../../hoc';
import stringify from 'fast-json-stable-stringify';
import useDeepCompareEffect from 'use-deep-compare-effect';
import ApexCharts from "apexcharts";

const ShearForceChart = ({
    series: { shearForces = [] },
    chartTitle = '',
    yLabel = '',
    xLabel = '',
    chartOptions = [],
    onLoad,
}) => {
    const [options, setOptions] = useState(chartOptions);
    const [seriesState, setSeriesState] = useState([
        {
            name: '',
            data: [],
        },
    ]);

    useDeepCompareEffect(() => {
        setSeriesState(() => {
            return [
                {
                    name: 'Z',
                    data: [
                        ...shearForces.reduce((acc, ele, index) => {
                            return [...acc, [ele, index * 0.1]];
                        }, []),
                    ],
                },
            ];
        });
    }, [shearForces]);

    useDeepCompareEffect(() => {
        const maxForce = Math.max(...shearForces);
        const minForce = Math.min(...shearForces);

        setOptions((state) => {
            const maxZ = Math.ceil(
                Math.max(...seriesState[0].data.map((ele) => ele[1])),
            );
            const maxVal = Math.max(Math.abs(maxForce), Math.abs(minForce));

            const { maxNum, maxTick } = chartsMaxYTick(maxZ);

            return {
                ...state,
                title: {
                    ...state['title'],
                    text: chartTitle,
                    margin: 20,
                    offsetY: 10,
                    floating: true
                },
                grid: {
                    ...state['grid'],
                    show: true,
                    padding: {
                        top: 50,
                        bottom: 20,
                    }  
                },
                fill: {
                    ...state['fill'],
                    colors: ['#66ff66'],
                },
                stroke: {
                    ...state['stroke'],
                    colors: ['#009900'],
                },
                subtitle: {
                    ...state['subtitle'],
                    align: 'center',
                    margin: 0,
                    offsetY: 90,
                    text: `Tmax - ${roundNumber(
                        maxForce,
                        2,
                    )} kNm, Tmin - ${roundNumber(minForce, 2)}kNm`,
                },
                yaxis: {
                    ...state['yaxis'],
                    tickAmount: maxTick,
                    max: maxNum,

                    title: {
                        ...state['yaxis']['title'],
                        text: yLabel,
                    },
                },
                xaxis: {
                    ...state['xaxis'],
                    max: 1.2 * maxVal,
                    min: -1.2 * maxVal,
                    tickAmount: 10,
                    
                    title: {
                        ...state['xaxis']['title'],
                        offsetY: 30,
                        text: xLabel,
                    },
                    labels: {
                        ...state['xaxis']['labels'],
                        offsetY: 10
                    }
                },
                dataLabels: {
                    ...chartOptions['dataLabels'],
                    offsetY: 0,
                    offsetX: 0,

                    formatter: function (x, opt) {
                        const currentVal = roundNumber(opt.w.globals.initialSeries[0].data[opt.dataPointIndex][0],0);
    
                        return currentVal === 0
                            ? 
                            ''
                            :
                            opt.dataPointIndex % 7 === 0
                            ?
                                currentVal
                            :
                            ''
                    },
                },
            };
        });
    }, [
        seriesState,
        shearForces,
        chartTitle,
        xLabel,
        yLabel,
    ]);

    useDeepCompareEffect(() => {
        let chart = new ApexCharts(document.querySelector("#shearChart"), {
            series: seriesState,
            ...options,
            chart: {
                ...options['chart'],
                type: 'area'
            }
        });
        chart.render();

        chart.dataURI().then(({ imgURI }) => {
            onLoad({ shearChart: imgURI })
        });

        return () => chart.destroy();
    },[seriesState, options]);

    return (
        <div id="shearChart"></div>
    );
};

export default React.memo(
    withDefaultPrintChart(ShearForceChart),
    (prev, next) => stringify(prev) === stringify(next),
);
